module.exports = __webpack_public_path__ + "assets/img/smartTV-module4-7.2b29411c.jpg";